
<template>
  <!-- 血压计列表 4G血压计 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
        @submit.native.prevent
      >
        <el-form-item label="设备编号">
          <el-input
            v-model.trim="formInline.inputdeviceno"
            placeholder="请输入设备编号"
            clearable
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
      
        <el-table
          :data="list"
          style="width: 100%"
          :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor"
        >
          <el-table-column
            label="设备编号"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
            </template>
          </el-table-column>
        
          <el-table-column
            label="设备名称"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.deviceName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设备描述"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="绑定老人姓名"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span
                style="margin-left: 10px; color: orange"
                v-if="
                  scope.row.oldmanName == null && scope.row.location == null
                "
                >暂未绑定</span
              >
              <span
                style="margin-left: 10px; color: red"
                v-else-if="
                  scope.row.oldmanName == null || scope.row.oldmanName == ''
                "
                >无</span
              >
              <span style="margin-left: 10px" v-else>{{
                scope.row.oldmanName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="350" align="center">
            <template slot-scope="scope">
              <el-button type="info" size="mini" plain @click="SmartPillboxData(scope.$index, scope.row)">详情</el-button>
              <el-button
                type="primary"
                size="mini"
                plain
                @click="SmartPillboxSetting(scope.$index, scope.row)"
                >修改提醒时间</el-button
              >
  
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>


   


    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import deviceLogTable from "@/components/DeviceLogTable";
import devicedetails from "@/components/DeviceDetails"
export default {
  components: { deviceLogTable ,devicedetails},
  data() {
    return {
      selectOldmanList: [], //select下拉菜单的老人集合
      addLoading: false,
      editLoading: false,
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      allList: [], //返回紧急按钮的集合  全部数据
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      oldmanNameIdList: [], //老人姓名和Id （用于下拉菜单展示老人以及绑定的时候 删除老人操作）
      oldmanIdNameUnshift: [], //用于解绑时 添加老人操作
      oldIdCard: [], //老人身份证
      oldmanList: [], //老人所有信息列表
      formInline: {
        inputdeviceno: "",
      },
      //绑定位置 ， 自定义 老人和床位
      dialogFormBangdi: false,
      logListVisible: false,
      currRecordDeviceNo:'',
      locationShow: true, //绑定床位的input 和 span 显示和隐藏的切换
      oldManShow: false, //选择老人的显示和隐藏
      bedShow: false, //选择床位信息的显示和隐藏
      locationBedShow: "", //如果是绑定类型为床位绑定   就把Cascader级联选择器选择的楼栋 层数 房间 床位  回显放到location绑定的位置
      cascadervalue: [], //Cascader级联选择器集合的值默认为空
      optionsBed: [], //床位号的Cascader级联选择器集合
      bindType: 0, //设备绑定的类型
      formBangdi: {
        location: "", //绑定的位置
        oldmanName: "", //老人姓名
        oldmanId: "", //老人id
        deviceId: "", //设备id
        oldIdCard: "", //老人身份证编号
        bedId: "", //床位id
        bindDeviceNo: "", //绑定模态框弹出的设备编号
      },
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
        // editaddress:'',
      },

      fileFlag: false,
    };
  },
  methods: {
    //点击查询
    onSubmit() {
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },




    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },

    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate,
            deviceType:43
          };
          console.log(param);
          this.addLoading = true;
          this.$postJson(
            "dmc/commonDevice/add",
            param
          ).then((res) => {
            //旧：dmc/button/add
            console.log(res);
            this.addLoading = false;
            this.dialogFormVisible = false;
            this.$refs.form.resetFields(); //移除校验结果并重置字段值
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
                this.getTableData();
              }, 300);
              console.log("提交成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
          });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },

    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceNo: this.formInline.inputdeviceno,
        deviceType: 43,//智能药盒
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/commonDevice/queryDeviceListWithPage", param).then(
        (res) => {
          console.log('详细数据',res);
          //判断是否有数据
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            this.list = res.result.list;
            res.result.list.forEach((item, index) => {
              if (item.location == null){
                this.$set(item, "status", true);
              }else if (item.location!='' || item.oldmanName!='' ) {
                this.$set(item, "status", false); //已绑定
              }else {
                this.$set(item, "status", true);
              }
            });
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    //详情
    SmartPillboxData(index, row) {
      console.log(row);
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!",
        });
      } else {
        this.formBangdi = Object.assign({}, row); //深拷贝数据
        var id = this.formBangdi.id;
        var oldName = this.formBangdi.oldmanName;
        var oldmanId = this.formBangdi.oldmanId;
        var deviceNo = this.formBangdi.deviceNo;
        bus.$emit("homePage", {
          type: "jump",
          path: "/SmartPillboxData",
          title: '智能药盒详情',
          params: {
            id: id,
            oldName: oldName,
            oldmanId: oldmanId,
            deviceNo:row.deviceNo
          }
        });
      }
    },
     SmartPillboxSetting(index, row) {
      console.log(row);
      if (row.bind == false) {
        this.$message({
          type: "error",
          message: "该设备还未绑定,请先绑定后再进行操作!",
        });
      } else {
        this.formBangdi = Object.assign({}, row); //深拷贝数据
        var id = this.formBangdi.id;
        var oldName = this.formBangdi.oldmanName;
        var oldmanId = this.formBangdi.oldmanId;
        var deviceNo = this.formBangdi.deviceNo;
        bus.$emit("homePage", {
          type: "jump",
          path: "/SmartPillboxSetting",
          title: '智能药盒修改',
          params: {
            id: id,
            oldName: oldName,
            oldmanId: oldmanId,
            deviceNo:row.deviceNo
          }
        });
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    },
  },

  created() {
    //组件创建完后获取数据，
    //此时 data 已经被 observed 了
    this.getTableData();
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
// 修改element-ui默认的样式
.del {
  color: red !important;
}
.fangqu {
  color: green !important;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dangerbuttonxz .el-dialog {
    width: 30% !important;
  }
}
//修改的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .dangerbuttonedit .el-dialog {
    width: 30% !important;
  }
}
//绑定紧急按钮位置和房间的dialog
@media screen and (min-width: 1200px) {
  ::v-deep .bangdilocation .el-dialog {
    width: 30% !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 1199px) {
  ::v-deep .bangdilocation .el-dialog {
    width: 55% !important;
  }
}
</style>